// The QueryClient default (0) marks data stale at once, so every window focus refetched every mounted query.
export const FOCUS_STALE_TIME_MS = 30_000;

// Each missing-documents fetch costs about three Alloy calls, and every ORP action that changes it invalidates it explicitly.
export const MISSING_DOCUMENTS_STALE_TIME_MS = 2 * 60_000;
